import { CloudAnalyticsModel } from "@doitintl/cmp-models";
import { getCollection } from "@doitintl/models-any";
import { useDocumentDataOnce } from "@doitintl/models-hooks";

import { useCachedHook } from "../../../Context/DynamicContext/useCachedHook";

function useNonCachedExtendedMetrics() {
  return useDocumentDataOnce(
    getCollection(CloudAnalyticsModel).doc("configs").collection("cloudAnalyticsConfigs").doc("extended-metrics")
  );
}

export function useExtendedMetrics() {
  return useCachedHook(useNonCachedExtendedMetrics);
}
